// extracted by mini-css-extract-plugin
module.exports = {"list":"AuthList_list__dHLko","link":"AuthList_link__1MyRE"};